module.exports = __webpack_public_path__ + "img/n01.b9a07740.png";